import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['inn', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-3,-3.5h0.5v0.5h-0.5zM-3.5,-3h0.5v0.5h-0.5zM-2.5,-3h0.5v0.5h-0.5zM2.5,-3h0.5v0.5h-0.5zM-3.5,-2.5h1v0.5h-1zM0,-2.5h0.5v1h-0.5zM-2.5,-2h0.5v0.5h-0.5zM-1,-2h0.5v0.5h-0.5zM-3.5,-1.5h1v0.5h-1zM-0.5,-1.5h1v0.5h-1zM-3.5,-1h1.5v1.5h-1.5zM-0.5,0h1v1.5h-1z',
    },
    {
      paint: [
        ['inn', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M3,-4h0.5v0.5h-0.5zM-3.5,-3.5h0.5v0.5h-0.5zM2,-3.5h1.5v0.5h-1.5zM-3,-3h0.5v0.5h-0.5zM-2,-3h1v1.5h-1zM1,-3h0.5v0.5h-0.5zM3,-3h0.5v0.5h-0.5zM0.5,-2.5h1v0.5h-1zM2.5,-2.5h1v0.5h-1zM-3.5,-2h1v0.5h-1zM0.5,-2h3v1h-3zM-2.5,-1.5h0.5v0.5h-0.5zM-1,-1.5h0.5v0.5h-0.5zM-0.5,-1h4v0.5h-4zM-0.5,-0.5h1v0.5h-1zM1,-0.5h2.5v1h-2.5zM-2,0.5h0.5v0.5h-0.5zM0.5,0.5h3v0.5h-3zM0.5,1h2v0.5h-2zM0,1.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['roofB', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-2,-6.5h1v0.5h-1zM-2.5,-6h1.5v0.5h-1.5zM-3,-5.5h2.5v0.5h-2.5zM-3.5,-5h3.5v0.5h-3.5zM-3.5,-4.5h4v0.5h-4zM-4,-4h5v0.5h-5zM2.5,-4h0.5v0.5h-0.5zM4,-4h1.5v1h-1.5zM-2.5,-3.5h4.5v0.5h-4.5zM0,-3h0.5v0.5h-0.5z',
    },
    {
      paint: 'roofB',
      d: 'M-0.5,-7.5h2v0.5h-2zM-1.5,-7h3.5v0.5h-3.5zM-1,-6.5h3.5v0.5h-3.5zM-1,-6h4v0.5h-4zM-0.5,-5.5h4v0.5h-4zM0,-5h3v0.5h-3zM0.5,-4.5h3.5v0.5h-3.5zM4.5,-4.5h1v0.5h-1zM1,-4h1.5v0.5h-1.5z',
    },
    {
      paint: 'trunk',
      d: 'M3,-5h2.5v0.5h-2.5zM0.5,-3h0.5v0.5h-0.5zM-2,-1.5h1v0.5h-1zM-2,-1h1.5v1.5h-1.5zM0.5,-0.5h0.5v1h-0.5zM-1.5,0.5h1v0.5h-1zM-1,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'lanternGlow',
      d: 'M-1,-3h1v1h-1zM1.5,-3h1v1h-1zM-2.5,-2.5h0.5v0.5h-0.5zM-0.5,-2h0.5v0.5h-0.5z',
    },
    { paint: 'innSign', d: 'M4,-4.5h0.5v0.5h-0.5zM5.5,-4.5h0.5v1.5h-0.5zM4,-3h2v0.5h-2z' },
  ],
  pixels: 241,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: [
        ['inn', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-3,-3.5h0.5v0.5h-0.5zM-3.5,-3h0.5v0.5h-0.5zM-2.5,-3h0.5v0.5h-0.5zM2.5,-3h0.5v0.5h-0.5zM-3.5,-2.5h1v0.5h-1zM0,-2.5h0.5v1h-0.5zM-2.5,-2h0.5v0.5h-0.5zM-1,-2h0.5v0.5h-0.5zM-3.5,-1.5h1v0.5h-1zM-0.5,-1.5h1v0.5h-1zM-3.5,-1h1.5v1.5h-1.5zM-0.5,0h1v1.5h-1z',
    },
    {
      paint: [
        ['inn', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M3,-4h0.5v0.5h-0.5zM-3.5,-3.5h0.5v0.5h-0.5zM2,-3.5h1.5v0.5h-1.5zM-2,-3h1v1.5h-1zM1,-3h0.5v0.5h-0.5zM3,-3h0.5v0.5h-0.5zM0.5,-2.5h1v0.5h-1zM2.5,-2.5h1v0.5h-1zM-3.5,-2h1v0.5h-1zM0.5,-2h3v1h-3zM-2.5,-1.5h0.5v0.5h-0.5zM-1,-1.5h0.5v0.5h-0.5zM-0.5,-1h4v0.5h-4zM-0.5,-0.5h1v0.5h-1zM1,-0.5h2.5v1h-2.5zM-2,0.5h0.5v0.5h-0.5zM0.5,0.5h3v0.5h-3zM0.5,1h2v0.5h-2zM0,1.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['roofB', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-2,-6.5h1v0.5h-1zM-2.5,-6h1.5v0.5h-1.5zM-3,-5.5h1v0.5h-1zM-1,-5.5h0.5v0.5h-0.5zM-3.5,-5h1.5v1h-1.5zM-1,-5h1v0.5h-1zM-1,-4.5h1.5v0.5h-1.5zM1.5,-4.5h0.5v0.5h-0.5zM-4,-4h2v0.5h-2zM-1,-4h2v0.5h-2zM4,-4h1.5v1h-1.5zM-2.5,-3.5h0.5v0.5h-0.5zM-1,-3.5h2.5v0.5h-2.5zM0,-3h0.5v0.5h-0.5z',
    },
    {
      paint: 'roofB',
      d: 'M-0.5,-7.5h2v0.5h-2zM-1.5,-7h3.5v0.5h-3.5zM-1,-6.5h2v0.5h-2zM1.5,-6.5h1v0.5h-1zM-1,-6h1.5v0.5h-1.5zM2,-6h1v1.5h-1zM-0.5,-5.5h1v0.5h-1zM0,-5h0.5v0.5h-0.5zM2,-4.5h2v0.5h-2zM4.5,-4.5h1v0.5h-1zM1,-4h1.5v0.5h-1.5z',
    },
    {
      paint: 'trunk',
      d: 'M1,-5h0.5v0.5h-0.5zM3.5,-5h2v0.5h-2zM-2,-1.5h1v0.5h-1zM-2,-1h1.5v1.5h-1.5zM0.5,-0.5h0.5v1h-0.5zM-1.5,0.5h1v0.5h-1zM-1,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'lanternGlow',
      d: 'M-1,-3h1v1h-1zM1.5,-3h1v1h-1zM-2.5,-2.5h0.5v0.5h-0.5zM-0.5,-2h0.5v0.5h-0.5z',
    },
    { paint: 'innSign', d: 'M4,-4.5h0.5v0.5h-0.5zM5.5,-4.5h0.5v1.5h-0.5zM4,-3h2v0.5h-2z' },
    { paint: 'wall', d: 'M0.5,-5h0.5v0.5h-0.5zM1.5,-5h0.5v0.5h-0.5zM0.5,-4.5h1v0.5h-1z' },
    {
      paint: [
        ['roofB', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M1,-6.5h0.5v0.5h-0.5zM0.5,-6h1.5v1h-1.5zM-2,-5.5h1v2.5h-1zM3,-5.5h0.5v1h-0.5zM2.5,-4h0.5v0.5h-0.5zM1.5,-3.5h0.5v0.5h-0.5zM-3,-3h0.5v0.5h-0.5zM0.5,-3h0.5v0.5h-0.5z',
    },
  ],
  pixels: 241,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: [
        ['inn', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-3,-3.5h0.5v0.5h-0.5zM-3.5,-3h0.5v0.5h-0.5zM-2.5,-3h0.5v0.5h-0.5zM2.5,-3h0.5v0.5h-0.5zM-3.5,-2.5h1v0.5h-1zM0,-2.5h0.5v1h-0.5zM-2.5,-2h0.5v0.5h-0.5zM-1,-2h0.5v0.5h-0.5zM-3.5,-1.5h1v0.5h-1zM-0.5,-1.5h1v0.5h-1zM-3.5,-1h1.5v1.5h-1.5zM-0.5,0h1v1.5h-1z',
    },
    {
      paint: [
        ['inn', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M3,-4h0.5v0.5h-0.5zM-3.5,-3.5h0.5v0.5h-0.5zM2,-3.5h1.5v0.5h-1.5zM-2,-3h1v1.5h-1zM1,-3h0.5v0.5h-0.5zM3,-3h0.5v0.5h-0.5zM0.5,-2.5h1v0.5h-1zM2.5,-2.5h1v0.5h-1zM-3.5,-2h1v0.5h-1zM0.5,-2h3v1h-3zM-2.5,-1.5h0.5v0.5h-0.5zM-1,-1.5h0.5v0.5h-0.5zM-0.5,-1h4v0.5h-4zM-0.5,-0.5h1v0.5h-1zM1,-0.5h2.5v1h-2.5zM-2,0.5h0.5v0.5h-0.5zM0.5,0.5h2.5v0.5h-2.5zM0.5,1h2v0.5h-2zM0,1.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['roofB', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-2,-6.5h1v0.5h-1zM-2.5,-6h1.5v0.5h-1.5zM-3,-5.5h1v0.5h-1zM-1,-5.5h0.5v0.5h-0.5zM-3.5,-5h1.5v1h-1.5zM-1,-5h1v0.5h-1zM-1,-4.5h1.5v0.5h-1.5zM-4,-4h2v0.5h-2zM-1,-4h2v0.5h-2zM4,-4h1.5v1h-1.5zM-2.5,-3.5h0.5v0.5h-0.5zM-1,-3.5h2.5v0.5h-2.5zM0,-3h0.5v0.5h-0.5z',
    },
    {
      paint: 'roofB',
      d: 'M-0.5,-7.5h2v0.5h-2zM-1.5,-7h3.5v0.5h-3.5zM-1,-6.5h3.5v0.5h-3.5zM-1,-6h4v0.5h-4zM-0.5,-5.5h4v0.5h-4zM0,-5h3v0.5h-3zM0.5,-4.5h3.5v0.5h-3.5zM4.5,-4.5h1v0.5h-1zM1,-4h1.5v0.5h-1.5z',
    },
    {
      paint: 'trunk',
      d: 'M3.5,-5h2v0.5h-2zM-2,-1.5h1v0.5h-1zM-2,-1h1.5v1.5h-1.5zM0.5,-0.5h0.5v1h-0.5zM3.5,0h0.5v1h-0.5zM5.5,0h0.5v1h-0.5zM-1.5,0.5h1v0.5h-1zM-1,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'lanternGlow',
      d: 'M-1,-3h1v1h-1zM1.5,-3h1v1h-1zM-2.5,-2.5h0.5v0.5h-0.5zM-0.5,-2h0.5v0.5h-0.5z',
    },
    { paint: 'innSign', d: 'M4,-4.5h0.5v0.5h-0.5zM5.5,-4.5h0.5v1.5h-0.5zM4,-3h2v0.5h-2z' },
    { paint: 'parkBench', d: 'M4,-1h1.5v0.5h-1.5zM3.5,-0.5h3v0.5h-3zM4,0h1.5v0.5h-1.5z' },
    {
      paint: 'fence',
      d: 'M-2,-5.5h1v2.5h-1zM3,-5h0.5v0.5h-0.5zM2.5,-4h0.5v0.5h-0.5zM1.5,-3.5h0.5v0.5h-0.5zM-3,-3h0.5v0.5h-0.5zM0.5,-3h0.5v0.5h-0.5zM3,0.5h0.5v0.5h-0.5zM6,0.5h1v0.5h-1zM3,1h2v0.5h-2zM5.5,1h1v0.5h-1zM4,1.5h1v0.5h-1z',
    },
  ],
  pixels: 267,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
